module.exports = __webpack_public_path__ + "img/5.ad6073f5.jpeg";